import { KubesoloStep, KubesoloTest } from '@api/types.gen';

import { ExpandableText } from './ExpandableText';
import { explainFailure } from './stepFailures';
import { stepLabels } from './steps';

interface Props {
  step: KubesoloStep;
  test: KubesoloTest;
  hideFix?: boolean;
}

/** A failed step in the user's terms, its fix, and the raw error behind Show details. */
export function FailureMessage({ step, test, hideFix }: Props) {
  const { message, fix, details } = explainFailure(step, test);

  return (
    <div className="flex flex-col gap-1">
      <div>
        <span className="font-semibold">{stepLabels[step.name]}:</span>{' '}
        {message}
      </div>

      {fix && !hideFix && (
        <div className="text-muted">
          <span className="font-semibold">Fix:</span> {fix}
        </div>
      )}

      {details && (
        <ExpandableText
          label="details"
          text={details}
          copyAriaLabel={`Copy the details of ${stepLabels[step.name]}`}
          wrapLines
          data-cy="kubesolo-failure-details"
        />
      )}
    </div>
  );
}
